import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=52056b5e&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"
import style0 from "./certificate.vue?vue&type=style&index=0&id=52056b5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52056b5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52056b5e')) {
      api.createRecord('52056b5e', component.options)
    } else {
      api.reload('52056b5e', component.options)
    }
    module.hot.accept("./certificate.vue?vue&type=template&id=52056b5e&scoped=true", function () {
      api.rerender('52056b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/staffCustomerManage/staffForm/certificate.vue"
export default component.exports